import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import {

} from "./Ceremony_packListCol"

//redux
import { useSelector, useDispatch } from "react-redux"
import { updateCeremony_pack,addNewCeremony_pack, getCeremonies_pack, deleteCeremony_pack } from '../../../store/ceremony-pack/actions'
import {
  getCeremonies,
} from "../../../store/ceremony/actions"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {CeremonyType,Price} from './Ceremony_packListCol'

function Ceremonies_pack() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [ceremony_pack, setCeremony] = useState([])
    const [offset, setOffset] = useState(0)
    const [page_size, setPageSize] = useState(10)
 const [selectedCeremony_type, setSelectedCeremonyType] = useState({})
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      price: (ceremony_pack && ceremony_pack.price) || "",
      is_active: (ceremony_pack && ceremony_pack.is_active) || 0,
    },

    validationSchema: Yup.object({
      price: Yup.string().required()
    }),

    onSubmit:async values => {

      if (isEdit) {
        const UpdateCeremony = {
          id: ceremony_pack ? ceremony_pack.id : 0,
          ceremony_type_id: selectedCeremony_type.value,
          price: values["price"],
          is_active: values["is_active"],
        }

        // update ceremony_pack
        dispatch(updateCeremony_pack(UpdateCeremony))
        dispatch(getCeremonies_pack())

        validation.resetForm()
      } else {
        
        const newCeremony = {
          // id: Math.floor(Math.random() * (30 - 20)) + 20,
          ceremony_type_id: selectedCeremony_type.value,
          price: values["price"],
          is_active: values["is_active"],
        }
        // save new ceremony_pack
        dispatch(addNewCeremony_pack(newCeremony))
        dispatch(getCeremonies_pack())
        validation.resetForm()
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const ceremonies = useSelector(state => state.ceremony.ceremony_pack.ceremonies_pack)
  const loading = useSelector(state => state.ceremony.ceremony_pack.loading)
  const ceremonies_type = useSelector(state => state.ceremony.ceremonies.ceremonies)
    const total_page = useSelector(
      state => state.ceremony.ceremony_pack.total_page
    )
  const ceremonies_typeOptions = ceremonies_type?.map(cer => {
    return { label: cer.name_en, value: cer.id }
  })
  
  function handleSelect(arg) {
    setSelectedCeremonyType(arg)
  }
  
  useEffect(() => {
      dispatch(getCeremonies_pack({offset,page_size}))
  }, [dispatch, offset, page_size])
  
  useEffect(() => {
   dispatch(getCeremonies({ is_active: 1, offset: "", page_size: "" }))
},[dispatch])

  useEffect(() => {
    if (!isEmpty(ceremonies)) {
      setIsEdit(false)
    }
  }, [ceremonies])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const ceremony_pack = arg

    setSelectedCeremonyType({label:ceremony_pack.ceremony_type_name,value:ceremony_pack.ceremony_type_id})
    setCeremony({
      id: ceremony_pack.id,
      price: ceremony_pack.price,
      is_active: ceremony_pack.is_active,
    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete ceremony_pack
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = ceremony_pack => {
    setCeremony(ceremony_pack)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony_pack.id) {
      dispatch(deleteCeremony_pack(ceremony_pack))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "ceremony type",
        accessor: "ceremony_type_name",
        filterable: true,
        Cell: cellProps => {
          return <CeremonyType {...cellProps} />
        },
      },
      {
        Header: "Price",
        accessor: "price",
        filterable: true,

        Cell: cellProps => {
          return <Price {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            { cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateCeremony_pack({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateCeremony_pack({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const ceremonies = cellProps.row.original
                      handleUserClick(ceremonies)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const ceremonies = cellProps.row.original
                      onClickDelete(ceremonies)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick,loading]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Ceremony package" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={ceremonies}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Ceremony type</Label>
                      <div className="mb-3">
                        <Select
                          value={selectedCeremony_type}
                          onChange={option => {
                            handleSelect(option)
                          }}
                          options={ceremonies_typeOptions}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Price</Label>
                      <Input
                        name="price"
                        type="number"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.price || ""}
                        invalid={
                          validation.touched.price && validation.errors.price
                            ? true
                            : false
                        }
                      />
                      {validation.touched.price && validation.errors.price ? (
                        <FormFeedback type="invalid">
                          {validation.errors.price}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Ceremonies_pack.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Ceremonies_pack
